// $(document).ready(function() {
//     $('.emailSignupButton').on('click', function() {
//         let alreadySetEmail = $('#newsletter-input').val();

//         $('#newsletter-mail').val(alreadySetEmail || $('#newsletter-mail').value);
//     });
//     $('.newsletter-form').on('submit', function(e) {
//         e.preventDefault();
//         const $form = $('.newsletter-form');
//         $form.spinner().start();
//         $.ajax({
//             url: $form.attr('action'),
//             type: 'post',
//             dataType: 'json',
//             data: $form.serialize(),
//             success: function (data) {
//                 if(!data.error){
//                     //Close newsletter modal
//                     $("#newsletter-form").modal('hide');
//                     //Open newsletter feedback modal to avoid modal overriding
//                     $("#newsletter-feedback-modal .content-title").text(data.titleMessage);
//                     $("#newsletter-feedback-modal .paragraph").text(data.bodyMessage);
//                     $("#newsletter-feedback-modal").modal('show');

//                     $('body').trigger('newsletter:success', data);
//                 }
//                 $form.spinner().stop();

//             },
//             error: function (err) {
//                 //Close newsletter modal
//                 $("#newsletter-form").modal('hide');
//                 $form.spinner().stop();
//             }
//         });
//     });
    
// });

$(document).ready(function() {

    $('.emailSignupButton').on('click', function() {
        let alreadySetEmail = $('#newsletter-input').val();
        $('#newsletter-mail').val(alreadySetEmail || $('#newsletter-mail').value);
    });

});

/**
 * Shows a submit error inside the form, falling back to the email field when
 * the form has no callback element.
 */
function showNewsletterError($form, message) {
    const $callback = $form.parent().find($form.data('replaceElement'));

    if ($callback.length) {
        $callback.text(message).addClass('error');
    } else {
        $form.find('#newsletter-mail-error').text(message);
        $form.find('#newsletter-mail').addClass('is-invalid');
    }
}

$(document).ready(function() {
    $('.newsletter-form button[type="submit"]').on('click', function(e) {
        e.preventDefault();

        var $form = $(this).closest('.newsletter-form');
        var isValid = true;

        // Pulisci errori precedenti
        $form.find('.invalid-feedback').text('');
        $form.find('.is-invalid').removeClass('is-invalid');
        $form.find('.radio-error').remove();
        $form.parent().find($form.data('replaceElement')).text('').removeClass('error');

        // Campi di testo
        var textFields = ['name', 'surname', 'mail'];
        textFields.forEach(function(f) {
            var $input = $form.find('#newsletter-' + f);
            var value = ($input.val() || '').trim();
            var $error = $form.find('#newsletter-' + f + '-error');

            if (!value) {
                $error.text('Compila questo campo');
                $input.addClass('is-invalid');
                isValid = false;
            } else if (f === 'mail' && !/^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/.test(value)) {
                $error.text('Email non valida');
                $input.addClass('is-invalid');
                isValid = false;
            }
        });

        // Campi radio
        var radioFields = [
            'dwfrm_profile_customer_marketing',
            'dwfrm_profile_customer_newsletter',
            'dwfrm_profile_customer_profilazione'];
        radioFields.forEach(function(r) {
            var $error = $form.find('#form-privacy-' + r.split('_').pop() + '-error');
            if (!$form.find('input[name="' + r + '"]:checked').length) {
                isValid = false;
                $error.text('Seleziona una di queste opzioni.').show();
            } else {
                $error.text('').hide();
            }
        });

        if (!isValid) return;

        // Spinner prima della chiamata AJAX
        $form.spinner().start();

        $.ajax({
            url: $form.attr('action'),
            type: 'post',
            dataType: 'json',
            data: $form.serialize(),
            success: function(data) {
                if (!data.error) {
                    // Chiudi il form e mostra feedback
                    $form.closest('.modal').modal('hide');
                    $("#newsletter-feedback-modal .content-title").text(data.titleMessage);
                    $("#newsletter-feedback-modal .paragraph").text(data.bodyMessage);
                    $("#newsletter-feedback-modal").modal('show');
                    $('body').trigger('newsletter:success', data);
                } else {
                    showNewsletterError($form, data.message);
                }
                setTimeout(function() {
                    $form.spinner().stop();
                }, 500);
            },
            error: function(xhr) {
                const message = (xhr.responseJSON && xhr.responseJSON.message)
                    || 'Non è stato possibile completare l\'iscrizione. Riprova più tardi.';

                showNewsletterError($form, message);
                setTimeout(function() {
                    $form.spinner().stop();
                }, 500);
            }
        });
    });
});


